import React from 'react';
import PropTypes from 'prop-types';
import { Input as RSInput } from 'reactstrap';

import BaseInput from '../BaseInput';

const inputTypes = `email
password
url
number
datetime
date
time
color
search
tel
text
file`.split('\n');

const Input = ({
  errorMessage,
  successMessage,
  helpText,
  hideLabel,
  id,
  onChange,
  label,
  type,
  busy,
  ...domAttributes
}) => (
  <BaseInput {
    ...{
      errorMessage,
      successMessage,
      helpText,
      hideLabel,
      id,
      onChange,
      label,
      busy,
    }}
  >
    <RSInput type={type} {...domAttributes} />
  </BaseInput>
);

Input.propTypes = {
  ...BaseInput.childPropTypes,
  type: PropTypes.oneOf(inputTypes),
};

Input.defaultProps = {
  ...BaseInput.defaultChildProps,
  type: 'text',
  busy: false,
};

export default Input;
export { inputTypes };
